function loaderObserver(): void {
  document.querySelectorAll('div.loader').forEach((loader) => {
    loader.ariaHidden = 'true';
    let parentElement = loader.parentElement;
    while (parentElement?.parentElement && parentElement.parentElement !== document.body && !(parentElement.parentElement instanceof Window) && (parentElement.tagName === 'BUTTON' || parentElement.classList.contains('justify-content-center'))) {
      parentElement = parentElement.parentElement;
    }
    if (parentElement) {
      parentElement.ariaLive ??= 'polite';
      if (!parentElement.ariaBusy) {
        parentElement.setAttribute('data-loader-busy', 'true');
      }
    }
  });

  document.querySelectorAll('[data-loader-busy="true"]').forEach((loaderParentElement) => {
    const updateAriaBusy = (): void => {
      (loaderParentElement as HTMLElement).ariaBusy = loaderParentElement.querySelector('div.loader.active') ? 'true' : 'false';
    };
    updateAriaBusy();
    new MutationObserver(updateAriaBusy).observe(loaderParentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  loaderObserver();

  new MutationObserver(loaderObserver).observe(document, { childList: true, subtree: true });
});
